import * as React from "react";
import { Divider } from "antd";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../../gvc/testNewForm/CpInput";

interface Props {
  provider: string;
}
export const ProviderAutoscaler: React.FC<Props> = ({ provider }) => {
  const allOptions = [
    { label: "random", value: "random" },
    { label: "most-pods", value: "most-pods" },
    { label: "least-waste", value: "least-waste" },
    { label: "price", value: "price" },
  ];

  return (
    <>
      <Divider orientation={"left"} orientationMargin={0}>
        Autoscaler
      </Divider>
      <CpFormItem>
        <CpLabel name={`${provider}.autoscaler.expander`}>Expanders</CpLabel>
        <CpDescription>
          <div>
            <div>
              Type of node group expander to be used in scale up. Available values:
              [random,most-pods,least-waste,price].
            </div>
            <div>
              Specifying multiple values separated by commas will call the expanders in succession until there is only
              one option remaining.
            </div>
            <div>Ties still existing after this process are broken randomly. (default "random")</div>
            <div>
              This is an ordered list, you can deselect,reselect to create the correct order of selection, from left to
              right.
            </div>
          </div>
        </CpDescription>
        <CpSelect
          name={`${provider}.autoscaler.expander`}
          mode="multiple"
          style={{ width: 600 }}
          options={allOptions}
        />
        <CpErrorWarning name={`${provider}.autoscaler.expander`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`${provider}.autoscaler.unneededTime`}>Unneeded Time</CpLabel>
        <CpDescription>
          How long a node should be unneeded before it is eligible for scale down (default 10m0s)
        </CpDescription>
        <CpInput style={{ width: 600 }} name={`${provider}.autoscaler.unneededTime`} />
        <CpErrorWarning name={`${provider}.autoscaler.unneededTime`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`${provider}.autoscaler.unreadyTime`}>Unready Time</CpLabel>
        <CpDescription>
          How long an unready node should be unneeded before it is eligible for scale down (default 20m0s)
        </CpDescription>
        <CpInput style={{ width: 600 }} name={`${provider}.autoscaler.unreadyTime`} />
        <CpErrorWarning name={`${provider}.autoscaler.unreadyTime`} />
      </CpFormItem>
      <CpFormItem>
        <CpLabel name={`${provider}.autoscaler.utilizationThreshold`}>Unready Time</CpLabel>
        <CpDescription>
          Sum of cpu or memory of all pods running on the node divided by node's corresponding allocatable resource,
          below which a node can be considered for scale down (default 0.7)
        </CpDescription>
        <CpInput style={{ width: 600 }} name={`${provider}.autoscaler.utilizationThreshold`} />
        <CpErrorWarning name={`${provider}.autoscaler.utilizationThreshold`} />
      </CpFormItem>
    </>
  );
};
